import React from "react";
import { Spin, Row, Col, Radio } from "antd";
import global from "../../../common/utility/global";
import Header from "../../../components/Header";
import Filters from "./Filters";
import KpiCard from "./KpiCard";
import ChartPanel from "./ChartPanel";
import anioMock from '../../../common/mock/anioMock';
import mesMock from '../../../common/mock/mesMock';
import GraficoVentasComparativo from "./GraficoVentasComparativo";
import GraficoDona from "./GraficoDona";
import ListaEstablecimientos from "./ListaEstablecimientos";
import TablaTopClientes from "./TablaTopClientes";
import { buildDashboardData, formatCurrency, formatNumber } from "./utils";
import "./styles.css";
import comprobanteService from "../../../service/ventas/comprobanteService";

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.state = {
            loading: true,
            moneda: "PEN",
            anios: anioMock.values,
            meses: mesMock.values,
            filter,
            dashboard: buildDashboardData(null, filter),
        };
    }

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeMoneda = (e) => {
        this.setState({ moneda: e.target.value });
    };

    handleClearFilters = () => {
        const filter = {
            anioInicio: global.fetchCurrentYear(),
            mesInicio: global.fetchCurrentMonth(),
            anioFin: global.fetchCurrentYear(),
            mesFin: global.fetchCurrentMonth(),
            flagNotaVenta: false,
        };
        this.setState({ filter, moneda: "PEN" });
        this.handleGenerateReport(filter);
    };

    handleGenerateReport = async (filter) => {
        this.setState({ loading: true });
        const response = await comprobanteService.dashboardResumen(filter);

        this.setState({
            dashboard: buildDashboardData(response, filter),
            loading: false,
        });
    };

    async componentDidMount() {
        await this.handleGenerateReport(this.state.filter);
    }

    render() {
        const { moneda } = this.state;
        const { kpis, comparativo, categorias, establecimientos, topClientes, estados, esMismoMes } = this.state.dashboard;
        const clave = moneda === "USD" ? "usd" : "pen";
        // Los textos dependen del periodo ya consultado (no del filtro que
        // se esta editando): un solo mes se compara contra el mes anterior.
        const periodo = esMismoMes ? "Mes" : "Periodo";
        const etiquetaTendencia = `vs ${periodo.toLowerCase()} anterior`;
        const tendencia = (kpi) => `${formatNumber(kpi.tendenciaPct)}%`;

        return (
            <div>
                <Header
                    title="Dashboard Resumen Ventas"
                    onClearFilters={this.handleClearFilters}
                    onSearch={() => this.handleGenerateReport(this.state.filter)}
                />
                <Filters filter={this.state.filter} anios={this.state.anios} meses={this.state.meses} onChange={this.handleChange} />
                <div className="resumen-moneda-toggle">
                    <Radio.Group value={moneda} onChange={this.handleChangeMoneda} buttonStyle="solid">
                        <Radio.Button value="PEN">S/ Soles</Radio.Button>
                        <Radio.Button value="USD">US$ Dólares</Radio.Button>
                    </Radio.Group>
                </div>
                <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
                    <div className="resumen-kpi-row">
                        <KpiCard
                            icon="shopping-cart"
                            iconColor="#2563eb"
                            iconBackground="#dbeafe"
                            label={`Ventas del ${periodo}`}
                            value={formatCurrency(kpis.ventas[clave].valor, moneda)}
                            tendenciaDireccion={kpis.ventas[clave].tendenciaDireccion}
                            tendenciaValor={tendencia(kpis.ventas[clave])}
                            tendenciaEtiqueta={etiquetaTendencia}
                        />
                        <KpiCard
                            icon="file-text"
                            iconColor="#16a34a"
                            iconBackground="#dcfce7"
                            label="Total de CPE"
                            value={formatNumber(kpis.comprobantes.valor, 0)}
                            tendenciaDireccion={kpis.comprobantes.tendenciaDireccion}
                            tendenciaValor={tendencia(kpis.comprobantes)}
                            tendenciaEtiqueta={etiquetaTendencia}
                        />
                        <KpiCard
                            icon="usergroup-add"
                            iconColor="#7c3aed"
                            iconBackground="#ede9fe"
                            label="Clientes Nuevos"
                            value={formatNumber(kpis.clientesNuevos.valor, 0)}
                            tendenciaDireccion={kpis.clientesNuevos.tendenciaDireccion}
                            tendenciaValor={tendencia(kpis.clientesNuevos)}
                            tendenciaEtiqueta={etiquetaTendencia}
                        />
                        <KpiCard
                            icon="dollar"
                            iconColor="#ea580c"
                            iconBackground="#ffedd5"
                            label="CPE Promedio"
                            value={formatCurrency(kpis.cpePromedio[clave].valor, moneda)}
                            tendenciaDireccion={kpis.cpePromedio[clave].tendenciaDireccion}
                            tendenciaValor={tendencia(kpis.cpePromedio[clave])}
                            tendenciaEtiqueta={etiquetaTendencia}
                        />
                    </div>

                    <Row gutter={16} type="flex">
                        <Col className="gutter-row" xs={24} xl={9}>
                            <ChartPanel title={`Ventas vs ${periodo} Anterior`}>
                                <GraficoVentasComparativo
                                    timeLine={comparativo.timeLine}
                                    actual={comparativo[clave].actual}
                                    anterior={comparativo[clave].anterior}
                                    nombreActual={esMismoMes ? "Este mes" : "Periodo actual"}
                                    nombreAnterior={esMismoMes ? "Mes anterior" : "Periodo anterior"}
                                    moneda={moneda}
                                />
                            </ChartPanel>
                        </Col>

                        <Col className="gutter-row" xs={24} md={12} xl={7}>
                            <ChartPanel title="Ventas por Categoría">
                                <GraficoDona
                                    datos={categorias[clave]}
                                    formatearValor={(valor) => formatCurrency(valor, moneda)}
                                    claveFormato={moneda}
                                    breakpointLeyendaInferior={1600}
                                />
                            </ChartPanel>
                        </Col>

                        <Col className="gutter-row" xs={24} md={12} xl={8}>
                            <ChartPanel title="Ventas por Establecimiento">
                                <ListaEstablecimientos datos={establecimientos[clave]} moneda={moneda} />
                            </ChartPanel>
                        </Col>
                    </Row>

                    <Row gutter={16} type="flex">
                        <Col className="gutter-row" xs={24} xl={15}>
                            <ChartPanel title="Top 10 Clientes por Ventas">
                                <TablaTopClientes clientes={topClientes[clave]} moneda={moneda} />
                            </ChartPanel>
                        </Col>

                        <Col className="gutter-row" xs={24} xl={9}>
                            <ChartPanel title="Estado de Cpe">
                                <GraficoDona datos={estados} leyendaEnLinea />
                            </ChartPanel>
                        </Col>
                    </Row>
                </Spin>
            </div>
        );
    }
}
